import { Component, ViewChild, ElementRef, OnInit, OnDestroy } from '@angular/core';
// import { FormControl, FormGroup } from '@angular/forms';
import { faRobot } from '@fortawesome/free-solid-svg-icons/faRobot';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons/faPaperPlane';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';
//import { faDocker } from '@fortawesome/free-brands-svg-icons/faDocker';
import { faCheck, faClose, faEdit, faPlay, faCode, faCoffee, faTasks, faDownload, faL } from '@fortawesome/free-solid-svg-icons';
import { CommonService } from 'src/app/shared/Utils/CommonService';
import { Constants } from 'src/app/shared/Utils/Constants';
// import { faL } from '@fortawesome/free-solid-svg-icons';
// import '../../../assets/css/style.css';
// import { Document, Paragraph, Packer, TextRun, File } from 'docx';
// import { saveAs } from 'file-saver';
// import { HtmlParser } from '@angular/compiler';
// import { asBlob } from 'html-docx-js-typescript';
// import { nextLine } from 'pdf-lib';
import Swal from 'sweetalert2';

import { DomSanitizer } from '@angular/platform-browser';
// import { text } from '@fortawesome/fontawesome-svg-core';
import * as FileSaver from 'file-saver';
import { interval, Subscription } from 'rxjs';
import { LoaderService } from 'src/app/shared/service/loader.service';
import { ToastMessageService } from 'src/app/shared/service/toast-message.service';
import  {SopService} from 'src/app/shared/service/sop.service';
import JSZip from 'jszip';

@Component({
    selector: 'app-codegenerate',
    templateUrl: './codegenerate.component.html',
    styleUrls: ['./codegenerate.component.scss'],
    standalone: false
})
export class CodegenerateComponent implements OnInit, OnDestroy {
  @ViewChild('messageContainer') messageContainer!: ElementRef;
  private apiPollingTimer!: Subscription;
  redditIcon = faRobot;
  odnoklassniki = faUser;
  spinner = faSpinner;
  faPaperPlane = faPaperPlane;
  faCoffee = faCoffee;
  faCheck = faCheck;
  faClose = faClose;
  faEdit = faEdit;
  faPlay = faPlay;
  faCode = faCode;
  faTask = faTasks;
  // faDocker = faDocker;
  faDownload = faDownload;
  UserDiv: any;
  UserQuesDiv: any;
  questionsArray: any[] = [];
  quesTableData: any;
  DevReqText: any = '';
  // DevReqData: string = '';
  DevUserReqData: any;
  userReq: boolean = false;
  // quesTable: boolean = false;
  userQuesReq: boolean = false;
  // DevReq: boolean = false;
  QuesIsDisable: boolean = false;
  isLoading: boolean = false;
  DevReqDataEnable: boolean = false;
  workLocation: any;
  preReq: any;
  docname: any;
  docname1: any;
  apistatus:boolean = false;
  processName: any;
  codelang: string[] = []; // To hold the selected values
  codingLanguages: string[] = ['Angular','Apex', 'AngularJS','AURA', 'C#', 'CSS','Dataweave', 'Dax','Django', 'HTML', 'Java', 'JavaScript','JSON','JSON (Azure Logic Apps)','LWC', 'MongoDB', 'MySQL', 'Node.js','Oracle', 'PHP', 'PostgreSQL','powershell','PySpark', 'Python', 'React', 'Ruby','ServiceNow','SQL','Terraform', 'TypeScript','Unix','Vue.js','XML','XML (Taleo Connect Client)','YAML'];
  formData = {
    userPrompt: ''
  }
  userOHR: any;
  filepath1: any;
  filestatus: boolean=true;
  uploadedContent!: string;
  stext: any;
  stext1: any;
  isspinner: boolean = false;

  constructor(public commonService: CommonService, public _sanitizer: DomSanitizer,
    private loaderService: LoaderService, private toastService: ToastMessageService,
    private sopService: SopService) {
  }

  ngOnInit(): void {
    this.getOHR();
   // this.stext=localStorage.getItem('userreq');
    this.stext1=localStorage.getItem('api');
   // this.startApiPolling();

  }

  ngOnDestroy(): void {
    // Stop API polling when the component is destroyed
    this.stopApiPolling();
  }
  startApiPolling() {
    // Call the createWorkbench API every 15 seconds
    this.apiPollingTimer = interval(15000).subscribe(() => {
      this.CreateWorkbench1();
    });

    // Stop the API polling after 3 to 4 minutes (adjust as needed)
    setTimeout(() => {
      this.stopApiPolling();
      console.log('API polling stopped after 3 to 4 minutes.');
    }, 60000); // 1 minute in milliseconds
  }
  stopApiPolling() {
    if (this.apiPollingTimer) {
      this.apiPollingTimer.unsubscribe();
    }
  }

  scrollToBottom(): void {
    try {
      this.messageContainer.nativeElement.scrollTop = this.messageContainer.nativeElement.scrollHeight;
    } catch (err) {
      console.error(err);
    }
  }

  promptSearchHidden: boolean = false;
  promptError: boolean = false;
  SubmitClick() {
    if (this.formData.userPrompt == '') {
      this.promptError = true;
    } else {
      this.promptError = false;
      this.promptSearchHidden = true;
      this.userReq = true;
      this.UserDiv = this.formData.userPrompt;
      this.formData.userPrompt = '';
      // this.quesTable = true;
      this.isLoading = true;
      this.getUserPromptResponse(this.UserDiv);
      setTimeout(() => { this.scrollToBottom() }, 500);
    }
  }

  getUserPromptResponse(userPrompt: any) {
    let url = Constants.config.UserPromptUrl;
    let body = {
      "user_id": this.userOHR,
      userPrompt: userPrompt
    }

    this.commonService.postMethodAxios(url, body).then((res: any) => {
      console.log(res);
      this.questionsArray = res.data;
      if (this.questionsArray.length > 0) {
        this.isLoading = false;
      //  this.clarifyapistatus();
      }
      setTimeout(() => { this.scrollToBottom() }, 500);

    }).catch((err: any) => {
      console.log(err);
      setTimeout(() => { this.scrollToBottom() }, 500);
    })

  }

  QuesSubmit() {

    console.log(this.questionsArray);
    this.isLoading = true;
    this.QuesIsDisable = true;
    this.UserQuesDiv = this.questionsArray;
    this.userQuesReq = true;
    // this.DevReq = true;
    let url = Constants.config.DevReqUrl;
    let body = {
      userPrompt: this.UserDiv,
      detailedrequirements: this.questionsArray
    }

    this.commonService.postMethodAxios(url, body).then((res: any) => {
      console.log(res);

      // this.DevReqText.Prerequisites = (typeof res.data.development_requirements_detail["Prerequisites"] === "object") ? JSON.stringify(res.data.development_requirements_detail["Prerequisites"]) : res.data.development_requirements_detail["Prerequisites"];

      // this.DevReqText.detailedOperationSteps = (typeof res.data.development_requirements_detail["Detailed Operation Steps"] === "object") ? JSON.stringify(res.data.development_requirements_detail["Detailed Operation Steps"]) : res.data.development_requirements_detail["Detailed Operation Steps"];

      this.DevReqText = `Developement Requirement Overview:\n${res.data.development_requirements_overview}\n\nDevelopement Requirement Details-\nPrerequisites:\n${res.data.development_requirements_detail.Prerequisites}\n\nDetailed Operation Steps:\n${res.data.development_requirements_detail["Detailed Operation Steps"]}\n\nExpected Result:\n${res.data.development_requirements_detail["Expected Results"]}\n\nNotes:\n${res.data.development_requirements_detail["Other Explanatory Notes"]}`;

      // this.DevReqData = 'Prerequisites:<br/>' + res.data.development_requirements_detail.Prerequisites + '<br/>Detailed Operation Steps:<br/>' + res.data.development_requirements_detail["Detailed Operation Steps"];
      // this.DevReqData = res.data.development_requirements_detail.replace(/\n/g, '<br/>');
      if (this.DevReqText != '')
        this.isLoading = false;

      setTimeout(() => { this.scrollToBottom() }, 500);
    }).catch((err: any) => {
      console.log(err);
      setTimeout(() => { this.scrollToBottom() }, 500);
    })
    setTimeout(() => { this.scrollToBottom() }, 500);
  }

  quesAnsEdit(data: any, index: any) {
    console.log(data, index);
    this.questionsArray.filter((val: any, i: any) => {
      if (i == index)
        val.answer_sample = data;
    })

    console.log(this.questionsArray);

  }

  // reqType: string = 'DirectSubmit';
  preReqData: any = '';
  DevReqTextEdit: boolean = false;
  DevReqEdit() {
    // this.subType = 'DevReqSubmit';
    // this.reqType = 'Edited';
    this.DevReqTextEdit = true;
    // this.formData.userPrompt = this.DevReqText;
  }

  devReqbtn: boolean = false;
  DevReqSubmit() {
    this.devReqbtn = true;
    this.isLoading = true;
    this.DevReqTextEdit = false;
    this.DevReqDataEnable = true;

    this.DevReqText = document.getElementById('devReqTxt')?.innerText;
    this.DevUserReqData = this.DevReqText.replaceAll('\n', '<br/>');

    // if (this.reqType == 'DirectSubmit') {
    //   this.DevUserReqData = this.DevReqData;
    // }
    // else {
    //   this.DevUserReqData = this.DevReqText;
    // }
    // this.formData.userPrompt = '';
    // this.DevUserReqData.replaceAll('<br/>', '\n');


    let req = `{"development_requirements_overview":'${this.UserDiv}',"development_requirements_detail":${this.DevReqText}}`;

    let obj = {
      development_requirements_detail: req
    }
    let url = Constants.config.clarifyApiUrl;
    console.log(obj);

    this.commonService.postMethodAxios(url, obj).then((res: any) => {
      console.log(res);
      this.preReqData = JSON.stringify(res.data, undefined, 4);
      console.log(this.preReqData);

      // this.preReq = `
      // <h5><b>The interface documentation has been generated, and once confirmed, the analysis of how to modify the program code will begin: </b></h5>
      // <br/>
      // <pre>${this.preReqData}</pre>
      // `;
      this.isLoading = false;
      setTimeout(() => { this.scrollToBottom() }, 500);

    }).catch((err: any) => {
      console.log(err);
      setTimeout(() => { this.scrollToBottom() }, 500);

    })
    setTimeout(() => { this.scrollToBottom() }, 500);
  }

  userDocCnfrm: boolean = false;
  gptCode: any[] = [];
  preReqTxtEdit: boolean = false;
  preReqBtn: boolean = false;
  DocCnfrm() {
    if(this.codelang.length == 0){
      this.isLoading = false;
      this.toastService.showError('Please select coding language');
      return;
    }

    this.filestatus=!this.filestatus;
    this.preReqData = document.getElementById('preReqTxt')?.innerText;
    this.preReqBtn = true;
    this.userDocCnfrm = true;
    this.isLoading = true;
    this.preReqTxtEdit = false;
    this.GenerateCode();

  }

  preReqEdit() {
    this.preReqTxtEdit = true;
  }

  GenerateCode() {


    let url = Constants.config.codeGenerationUrl;
    // let req = `
    // {'swagger_api':'${this.UserDiv}','development_requirements_detail':${this.DevUserReqData}}
    // `;
    interface MyObject {
      user_id: any;
      api_status: boolean;
      development_requirements_detail: any;
      swagger_api?: any; // Optional property
      process_name:any;
      language?:any;
    }

    // Define obj with initial properties
    let obj: MyObject = {
      "user_id": this.userOHR,
      api_status: this.apistatus,
      development_requirements_detail: this.stext,
      process_name:this.processName,
      language: this.codelang.join(',')// Convert the array to a comma-separated string

    };

    // Conditionally add swagger_api property if api_status is true
    if (this.apistatus) {
      obj.swagger_api = this.stext1;
    }
 else if(this.apistatus == false){
  obj.swagger_api = '';
 }
    // Now obj will either contain 'swagger_api' if api_status is true, otherwise, it won't

    // Use obj as needed in your component


    this.commonService.postMethodAxios(url, obj).then((res: any) => {
      this.checkinitialcodestatus();
      console.log(res);
      // this.filepath1=res.data.filepath;
      // this.gptCode = res.data;

    }).catch((err) => {
      console.log(err);
      setTimeout(() => { this.scrollToBottom() }, 500);
    })
    setTimeout(() => { this.scrollToBottom() }, 500);

  }


  async DownloadUserRequirement() {

    console.log(this.DevReqText);
    this.DevReqText = document.getElementById('devReqTxt')?.innerText;
    // const text = "Your plain text goes here.";
    const filename = "User_Requirement.docx";
    this.saveAsDoc(this.DevReqText, filename);

    // this.saveToFile(this.DevReqText, 'User_Requirements.docx');


    // const doc = new Document({
    //   sections: [
    //     {
    //       properties: {},
    //       children: [
    //         new Paragraph({
    //           text:this.DevReqText
    //         })
    //       ],
    //     },
    //   ],
    // });


    // Packer.toBlob(doc).then(blob => {
    //   console.log(blob);

    //   saveAs(blob, "User_Requirement.docx");
    //   console.log("Document created successfully");
    // });

  }

  saveAsDoc(text: string, filename: string) {
    const blob = new Blob([text], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });

    FileSaver.saveAs(blob, filename);
  }
    // Download the file
    downloadFile(data: any): void {
  const payload = {
    "workspace_location": data
  }

      this.sopService.downloadzip(payload).subscribe(
        (response: any) => {
          // Create a Blob from the response
          const blob = new Blob([response], { type: 'application/zip' });

          // Create a link element, set its href, and simulate a click
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          const filename = this.processName || '';
          link.download = `${filename}.zip`; // Set the desired file name
          document.body.appendChild(link);
          link.click();

          // Clean up resources
          document.body.removeChild(link);
          window.URL.revokeObjectURL(link.href);
        },
        (error) => {
          console.error('Error downloading file:', error);
          // Handle error as needed
        }
      );
    }

  // saveToFile(text: string, filename: string) {
  //   const element = document.createElement('a');
  //   const file = new Blob([text], { type: 'text/plain' });

  //   element.href = URL.createObjectURL(file);
  //   element.download = filename;

  //   document.body.appendChild(element);
  //   element.click();

  //   document.body.removeChild(element);
  // }
  getOHR() {
    let userData = localStorage.getItem('okta-token-storage');
    if (userData) {
      let ohr_id = JSON.parse(userData)?.accessToken?.claims?.OHR;
      if (ohr_id) {
        this.userOHR = ohr_id;
      }
    }
  }

  featureBranch: any;
  CreateWorkbench() {
    this.isLoading = true;
    let url = Constants.config.createWorkbench;
const formData = new FormData();
    formData.append('user_id', this.userOHR);



    this.commonService.postMethodAxios1(url, formData).then((res: any) => {
      console.log(res);
      this.toastService.showSuccess(res.data.message);
      this.workLocation = res.data.workspace_location;
      // this.isLoading = false;
      this.featureBranch = res.data.feature_branch;
      if (this.workLocation != null || this.workLocation != undefined || this.workLocation != '') {

        let body = {
          filepath: this.filepath1,
          code: this.DevReqText
        }
        // this.saveCode(body);
        // this.Starting();
       this.startApiPolling();
       // this.CreateWorkbench1();
        // this.gptCode.forEach((ele: any) => {
        //   var rslt = this.checkCode(ele);
        //   console.log(rslt);

        //   var checklintrslt = this.checkLint(ele);
        //   console.log(checklintrslt);

        //   if (rslt != undefined || rslt != null || rslt != '' || checklintrslt != undefined || checklintrslt != null) {
        //     ele.selfCheck = rslt;
        //     ele.checklint = checklintrslt;
        //     ele.adjustCode = undefined;
        //   }
        //   // this.saveCode(ele);
        // });
        console.log(this.gptCode);

      }
    }).catch((err) => {
      console.log(err);

      this.isLoading = false;
    })
  }
  CreateWorkbench1() {
    this.isLoading = true;
    this.isspinner=true
    let url = Constants.config.createWorkbench1;
const formData = new FormData();
    formData.append('user_id', this.userOHR);



    this.commonService.postMethodAxios1(url, formData).then((res: any) => {
      console.log(res);
      this.workLocation = res.data.workspace_location;
      this.toastService.showSuccess(res.data.result !== true ?res.data.message:"Workspace has been created");
      this.featureBranch = res.data.feature_branch;
      //this.workLocation = res.data.reason;
      if(res.data.result == true){
        this.stopApiPolling();
      }
      this.isLoading = false;
      this.isspinner=false
      this.featureBranch = res.data.feature_branch;
      if (this.workLocation != null || this.workLocation != undefined || this.workLocation != '') {

        let body = {
          filepath: this.filepath1,
          code: this.DevReqText
        }
        this.saveCode(body);
        this.Starting();
        // this.saveCode(body);
        // this.Starting();
        // this.gptCode.forEach((ele: any) => {
        //   var rslt = this.checkCode(ele);
        //   console.log(rslt);

        //   var checklintrslt = this.checkLint(ele);
        //   console.log(checklintrslt);

        //   if (rslt != undefined || rslt != null || rslt != '' || checklintrslt != undefined || checklintrslt != null) {
        //     ele.selfCheck = rslt;
        //     ele.checklint = checklintrslt;
        //     ele.adjustCode = undefined;
        //   }
        //   // this.saveCode(ele);
        // });
        console.log(this.gptCode);

      }
    }).catch((err) => {
      console.log(err);

      this.isLoading = false;
    })
  }
  Starting(){
    this.gptCode.forEach((ele: any) => {
      var rslt = this.checkCode(ele);
      console.log(rslt);

      var checklintrslt = this.checkLint(ele);
      console.log(checklintrslt);

      if (rslt != undefined || rslt != null || rslt != '' || checklintrslt != undefined || checklintrslt != null) {
        ele.selfCheck = rslt;
        ele.checklint = checklintrslt;
        ele.IsRestartLoading = false;
        // ele.IsAdjusted = false;
        // ele.adjustCode = undefined;
      }
      // this.saveCode(ele);
    });
  }

  saveCode(data: any) {
    let url = Constants.config.saveCode;

    let body = {
      workspace_location: this.workLocation,
     // file_path: 'codes/' + data.filepath,
      file_path: data.filepath?data.filepath:'User_Requirement.doc',
      code: data.code
    }

    this.commonService.postMethodAxios(url, body).then((res: any) => {
      console.log(res);
    }).catch((err) => {
      console.log(err);
    })

  }

  pushCode() {
    let url = Constants.config.pushCode;

    let body = {
      workspace_location: this.workLocation,
      featureBranch: this.featureBranch
    }

    this.commonService.postMethodAxios(url, body).then((res: any) => {
      console.log(res);
      if (res.status == 200) {
        this.toastService.showSuccess(res.data.reason);
        Swal.fire('Thank you...', res.data.reason, 'success');
        this.downloadFile(this.workLocation);
      } else {
        Swal.fire('Sorry...', 'Something went wrong!', 'error');
      }
    }).catch((err) => {
      console.log(err);
      Swal.fire('Sorry...', 'Something went wrong!', 'error');
    })
  }

  editFileTaskPopup: boolean = false;
  editFileData: any;
  // editFileLoad: string = 'Loaded';
  adjustCodebtn(data: any) {
    this.editFileTaskPopup = true;
    const hbtn2 = document.getElementById('hbtn2') as HTMLButtonElement;
        if (hbtn2) {
            hbtn2.click(); // First click
            setTimeout(() => {
                hbtn2.click(); // Second click after a short delay
            }, 200); // Adjust the delay as needed
        }
    this.editFileData = data;
  }
  openModal() {
    this.editFileTaskPopup = true;
  }

  closeModal() {
    this.editFileTaskPopup = false;
    this.fileTaskError = false;
  }
  adjustCodeTableData: any;
  adjustCodeSubmit(path: any) {

    if (this.newFileTask == '' || this.newFileTask == undefined || this.newFileTask == null) {
      this.fileTaskError = true;
    }
    else {

      this.gptCode.filter((val: any) => {
        if (val.filepath == path) {
          val.adjustCode = this.newFileTask;
          val.IsAdjusted = true;
          // val.filepath = document.getElementById('filepathModified')?.innerText
        }
      })

      this.editFileTaskPopup = false;
    }

  }

  newFileTask: any;
  fileTaskError: boolean = false;
  EditFileTask(index:any) {

    this.gptCode.filter((v:any,i:any)=>{
      if(i == index){
        v.IsRestartLoading = true;
      }
    })

    // if (this.newFileTask == '' || this.newFileTask == undefined || this.newFileTask == null) {
    //   this.fileTaskError = true;
    // }
    // else {
    //   this.fileTaskError = false;
      // this.editFileLoad = 'Loading';
      let url = Constants.config.editFileTask;
      let data = {
        new_task: this.newFileTask, //document.getElementById("NewFileTask")?.innerText,
        new_code: this.editFileData.code,
        file_task: this.editFileData.code_interpreter
      }

      this.commonService.postMethodAxios(url, data).then((res: any) => {
        console.log(res);
        let datas = {
          code: res.data.code,
          code_interpreter: this.newFileTask, //document.getElementById("NewFileTask")?.innerText, //res.data.reasoning,
          filepath: this.editFileData.filepath
        }
        if (res.status == 200) {
          this.checkCode(datas, 'restart').then((res: any) => {
            if (res != null) {
              // this.editFileLoad = 'Loaded';
              // this.editFileTaskPopup = false;
              this.newFileTask = '';
              this.gptCode.filter((v:any,i:any)=>{
                if(i == index){
                  v.IsRestartLoading = false;
                }
              })
            }
          });
        }
      }).catch((err: any) => {
        console.log(err);
      })
      // this.saveCode(data);
    // }
  }

  codeEdit: boolean = false;
  codeData: any;
  EditConsoleEnable: boolean = false;
  editBtnHidden: boolean = false;
  updatedCode: any;
  reviewCode(data: any) {
    this.codeData = data;
    this.codeEdit = true;
    const hbtn3 = document.getElementById('hbtn3') as HTMLButtonElement;
    if (hbtn3) {
        hbtn3.click(); // First click
        setTimeout(() => {
            hbtn3.click(); // Second click after a short delay
        }, 200); // Adjust the delay as needed
    }
    this.EditConsoleEnable = false;
  }

  editClose() {
    this.codeEdit = false;
    this.editBtnHidden = false;
  }

  enableCodeEditor() {
    // this.codeEdit = false;
    this.EditConsoleEnable = true;
    this.editBtnHidden = true;
  }

  updateCode(data: any, type: any) {

    switch (type) {
      case "editCode":
        var editedCode = document.getElementById('code')?.innerText;
        console.log(editedCode);

        this.gptCode.filter((ele: any) => {
          if (ele.filepath == this.codeData.filepath) {
            ele.updatedCode = editedCode;
          }
        })

        this.editBtnHidden = false;
        this.codeEdit = false;
    this.editBtnHidden = false;
        break;

      case "normal":
        this.gptCode.filter((ele: any) => {
          if (ele.filepath == data.filepath) {
            ele.updatedCode = data.code;
            // ele.code_interpreter = data.code_interpreter
          }
        })
        break;
      case 'restart':
        this.gptCode.filter((ele: any) => {
          if (ele.filepath == data.filepath) {
            ele.code = data.code;
            // ele.code_interpreter = data.code_interpreter
          }
        });
        this.Starting();
        break;
    }
  }

  checkCode(data: any, type:string = 'normal') {
    let url = Constants.config.codeCheck;
    let body = {
      code: data.code,
      filetask: data.code_interpreter
    }

    var rslt = this.commonService.postMethodAxios(url, body).then((res: any) => {
      console.log(res);
      if (res.status == 200) {
        let values = {
          filepath: data.filepath,
          code: res.data.code,
          // code_interpreter: data.code_interpreter //res.data.reasoning
        }
        this.saveCode(values);
        this.updateCode(values, type);
        return res.data;
      }

    }).catch((err) => {
      console.log(err);
      return err;
    })

    return rslt;
  }

  selfCheckReason: any;
  selfCheckCode: any;
  selfCheckPopup: boolean = false;
  selfcheckFilepath: any;
  selfCheckBtn(data: any, path: any, type: any) {
    try {
      // Trigger the Bootstrap modal
      this.selfCheckPopup = true;
      const hbtn = document.getElementById('hbtn') as HTMLButtonElement;
        if (hbtn) {
            hbtn.click(); // First click
            setTimeout(() => {
                hbtn.click(); // Second click after a short delay
            }, 200); // Adjust the delay as needed
        }

      // Set modal content based on the type
      switch (type) {
        case 'SelfCheck':
          this.selfCheckReason = `<b>Review: ${data.reasoning}</b>`;
          this.selfCheckCode = data.code;
          this.selfcheckFilepath = path;
          break;
        case 'InitialCode':
          this.selfCheckReason = 'Initial Code';
          this.selfCheckCode = data.code;
          this.selfcheckFilepath = path;
          break;
        case 'StaticScan':
          this.selfCheckReason = data.reasoning;
          this.selfCheckCode = data.message;
          this.selfcheckFilepath = path;
          break;
        default:
          // Handle default case
          break;
      }
    } catch (error) {
      // Handle the error silently (without logging it to the console)
      console.error('An error occurred while triggering the Bootstrap modal:', error);
    }
  }


  selfCheckClose() {
    this.selfCheckPopup = false;
  }

  checkLint(data: any) {
    let url = Constants.config.checkLint;
    let body = {
      file_path: data.filepath,
      workspace_location: this.workLocation
    }

    var checkrslt = this.commonService.postMethodAxios(url, body).then((res: any) => {
      console.log(res);
      return res.data;
    }).catch((err) => {
      console.log(err);
      return err;
    })

    return checkrslt;

  }
  test(){
    this.toastService.showSuccess('changes saved successfully');
  }
  handleFileInput(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.docname1 = file.name;
      const extension = file.name.split('.').pop()?.toLowerCase();
      if (extension === 'txt'  ) {
        const reader = new FileReader();
        reader.onload = () => {
          this.uploadedContent = reader.result as string;
          this.stext1 = this.uploadedContent;
        };
        reader.readAsText(file); // Read file as text
      }
      else if (extension === 'docx') {
        this.readDocxFile1(file);
      }
      else {
        this.toastService.showError('Unsupported file format. Please upload only .txt, .docx files.');
      }
    }
  }

  handleFileChange(event: any) {
    this.isLoading = true;

    const file = event.target.files[0];
    if (file) {
      this.docname = file.name;
      this.toastService.showmessage(file.name + ' is being uploaded');
      const extension = file.name.split('.').pop()?.toLowerCase();
      if (extension === 'txt' ) {
        this.readFile(file);
      } else if (extension === 'docx') {
        this.readDocxFile(file);
      } else {
        this.toastService.showError('Unsupported file format. Please upload only .txt or .docx files.');
      }
    }
  }

  readFile(file: File) {
    //this.filestatus=!this.filestatus;
   // this.filestatus1=!this.filestatus1;
    const reader = new FileReader();
    reader.onload = () => {
      this.uploadedContent = reader.result as string;
      this.stext = this.uploadedContent;
      this.toastService.showSuccess('File has been uploaded successfully');
      this.isLoading = false;
    };
    reader.readAsText(file);
  }

  readDocxFile(file: File) {
    this.isspinner=true
   this.sopService.uploaddocx(file).subscribe
    ((res: any) => {
      this.isspinner=false
      console.log(res);
      this.stext = res.data;
      this.toastService.showSuccess('File has been uploaded successfully');
      this.isLoading = false;
    },
    (error: any) => {
      this.isspinner=false
      console.log(error);
    }

    );



  }
  readDocxFile1(file: File) {
    this.isspinner=true
   this.sopService.uploaddocx(file).subscribe
    ((res: any) => {
      this.isspinner=false
      console.log(res);
      this.stext1 = res.data;
    },
    (error: any) => {
      this.isspinner=false
      console.log(error);
    }

    );



  }

  extractTextFromXml(xmlDoc: Document): string {
    // Implement logic to traverse the XML structure and extract text content
    // You can use XPath expressions to target specific elements
    let text = '';
    const paragraphs = xmlDoc.getElementsByTagName('p');
    for (let i = 0; i < paragraphs.length; i++) {
      // Consider using childNodes or textContent depending on your needs
      text += paragraphs[i].textContent + '\n'; // Adjust if necessary
    }

    // You can add logic to handle other elements (headings, lists, etc.)

    return text;
  }
checkinitialcodestatus() {
  this.isLoading = true;
  const payload = new FormData();
  payload.append('user_id', this.userOHR);

  this.sopService.generateinitialcodestatus(payload).subscribe(
    (response: any) => {
      console.log(response);
      if (response.message == "Code generation is completed successfully") {
        this.filepath1=response.data.filepath;
        this.gptCode = response.data;
        this.isLoading = false;
        if (this.gptCode.length > 0) {
          this.toastService.showSuccess('code has been generated successfully');

          this.CreateWorkbench();
          setTimeout(() => { this.scrollToBottom() }, 500);
        }
      }
      else if(response.response == 'something went wrong'){

          response?.data?this.toastService.showSuccess(response.data):''; // Show the message
           this.toastService.showmessage(response.message);
          // this.checkinitialcodestatus(); // Call itself after 15 seconds


      }
      else if(response.message == 'Code creation is in progress' || 'Code creation is started') {
        setTimeout(() => {


          this.checkinitialcodestatus(); // Call itself after 15 seconds
        }, 15000);
          // const filepath2 = JSON.parse(response.data)?.filepath;
          // filepath2 ? this.toastService.showSuccess(filepath2 + ' has been generated') : console.log("No data received from the server");
          if (response && response.data) {
            const rawData = response.data.trim(); // Remove leading/trailing whitespace
            const dataObjects = rawData.match(/({[^}]*})/g); // Extract individual JSON objects
            if (dataObjects) {
                dataObjects.forEach((obj: string) => {
                    const data = JSON.parse(obj);
                    if (data && data.filepath) {
                        this.toastService.showmessage(data.filepath + ' is being created');
                    } else {
                        console.error("Filepath is undefined");
                    }
                });
            } else {
                console.error("No data objects found");
            }
        } else {
            console.error("No data received from the server");
        }

      }
      else{
        this.isLoading = false;
        this.toastService.showError('code generation failed');
      }
    },
    (error) => {
      this.isLoading = false;
      console.error('Error downloading file:', error);
      // Handle error as needed
    }
  );

}
}
class Response {
  msgClass: any;
  msgIcon: any;
  msgIconClass: any;
  msgContent: any;
  SubmitBtnDisable: boolean = false;
  EditBtnDisable: boolean = false;
  submitmethod: any;
  editMethod: any;
  submitHidden: boolean = true;
  editHidden: boolean = true;
}
